import type { FC } from "react";
import { useWatch } from "react-hook-form";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { BoxedSliderFormField } from "web_myplann/Inspiration/Components/BoxedSliderFormField";
import { InspirationSheet } from "web_myplann/Inspiration/Components/InspirationSheet";
import { RetirementLoanKindFormField } from "web_myplann/Inspiration/Retirement/Components/RetirementLoanKindFormField";
import {
	RETIREMENT_LOAN_AMOUNT_MAX,
	RETIREMENT_LOAN_AMOUNT_MIN,
	RETIREMENT_LOAN_AMOUNT_STEP,
} from "web_myplann/Inspiration/Retirement/constants";
import { useRetirementLoanForm } from "web_myplann/Inspiration/Retirement/Forms/useRetirementLoanForm";
import type { RetirementLoanFormModel } from "web_myplann/Inspiration/Retirement/Types/RetirementTypes";

const S = Resources.Inspiration.Retirement.AddLoanSheet;

type Props = {
	open: boolean;
	retirementYear: number;
	onClose: () => void;
	onSubmit: (drop: RetirementLoanFormModel) => void;
};

export const RetirementAddLoanSheet: FC<Props> = ({
	open,
	retirementYear,
	onClose,
	onSubmit,
}) => {
	const { t } = useResource();
	const { control, handleSubmit, currentYear, lastYear } =
		useRetirementLoanForm({ open, retirementYear });
	const endYear = useWatch({ control, name: "endYear" });

	return (
		<InspirationSheet
			open={open}
			onClose={onClose}
			title={t(S.title)}
			description={t(S.description)}
			primaryLabel={t(S.submit)}
			onPrimary={handleSubmit(onSubmit)}
		>
			<RetirementLoanKindFormField control={control} />

			<BoxedSliderFormField
				control={control}
				name="amount"
				label={t(S.amountLabel)}
				min={RETIREMENT_LOAN_AMOUNT_MIN}
				max={RETIREMENT_LOAN_AMOUNT_MAX}
				step={RETIREMENT_LOAN_AMOUNT_STEP}
			/>

			<BoxedSliderFormField
				control={control}
				name="endYear"
				label={t(S.yearLabel)}
				min={currentYear}
				max={lastYear}
				step={1}
				formatValue={String}
				minLabel={String(currentYear)}
				maxLabel={String(lastYear)}
				hint={t(
					endYear <= retirementYear ? S.yearHintBefore : S.yearHintAfter,
					{ year: retirementYear },
				)}
			/>
		</InspirationSheet>
	);
};
